import React from 'react'

import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import Drmahreen_CV from '../../../assets/CVs/Microbiology/Drmahreen_CV.pdf'
import DrNadiaBibi_CV from '../../../assets/CVs/Microbiology/DrNadiaBibi_CV.pdf'

import Footer from '../../../Components/Footer'
const Microbiology = () => {
  return ( 
    <>
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Microbiology</h2>
        <div className="underline"></div>
        <p> Faculty of Microbiology.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Mehreen</h4>
              <span>Lecturer Department of Microbiology.</span>
              <p>Lecturer Department of  Microbiology Shaheed Benazir Bhutto Women University Peshawar .</p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   microkust@gmail.com    </p>
              <div className="social">
                <a href={Drmahreen_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Nadia Bibi </h4>
              <span>Assistant Professor Department of Microbiology.</span>
              <p>Assistant Professor at the Department of Microbiology, Shaheed Benazir Bhutto Women University Peshawar .</p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> nadiabibi@sbbwu.edu.pk    </p>
              <div className="social">
                <a href={DrNadiaBibi_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 
 

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
   

      
    </>
  )
}

export default Microbiology
  